export default __webpack_public_path__ + "be1c758895d9e92e9b78af0931fb229a.png";